export class CpiAccountsUtil {
  public static checkIfDuplicateIdNotUnique = (errors) => {
    const customErrorException = errors?.CustomErrorException;
    if (customErrorException[0] && customErrorException[0].includes('1062')) {
      return 'ID key is duplicated. Please provide an unique ID.';
    }
  };
}
